import { updateUser, UpdateCustomer } from "../../api/services/userService.js";
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["setStoreLoaded", "currentStoreDoc"]),
    submitForm() {
      var that = this;
      let cms = [];
      let detail = this.$refs.myDetail.validate();

      cms.push(detail);
      Promise.all(cms).then((values) => {
        if (values.every((v) => v)) {
          that.saveProfile();
        } else {
          that.$el.querySelector("[aria-invalid=true]").focus();
        }
      });
    },
    saveProfile() {
      this.loading = true;
      updateUser(this.user.id, {
        FirstName: this.detailModel.FirstName,
        LastName: this.detailModel.LastName,
        DisplayName:
          this.detailModel.FirstName + " " + this.detailModel.LastName,
        FirebaseUDID: this.user.id,
        Mobile: this.detailModel.Phone,
        Email: this.user.email,
        DeliveryAddress: {
          Phone: this.detailModel.Phone,
        },
      })
        .then(() => {
          UpdateCustomer(this.user.id, {
            FirstName: this.detailModel.FirstName,
            LastName: this.detailModel.LastName,
            Mobile: this.detailModel.Phone,
            PhoneNumber: this.detailModel.Phone,
            Email: this.user.email,
            HQCompanyID: this.currentStoreDoc.HQCompanyID,
          }).then((response) => {
            if (response.data.Success) {
              this.success = true;
              setTimeout(() => {
                this.success = false;
              }, 2000);
              this.hasError = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.hasError = response.data.Status.Message;
            }
          });
        })
        .catch((error) => {
          this.loading = false;
          this.hasError = error;
        });
    },
    initModel() {
      this.detailModel.FirstName = this.dbuser.FirstName;
      this.detailModel.LastName = this.dbuser.LastName;
      this.detailModel.Email = this.user.email;
      this.detailModel.Phone = this.dbuser.Mobile;
    },
  },
};
